<script setup>
	import { ref, onMounted} from 'vue'
	import { useRouter, RouterLink } from 'vue-router'
	import GovHeader from "@/components/shell/GovHeader.vue"
	import DropDownMenu from "@/components/shell/DropDownMenu.vue"

	//reactive field proxies
	const aboutMenu = ref([])

	//binding to invoke method on child componenet
	const childRefMenu = ref({})
	const childRefMenuToggle = ref({})

	//local variables
	const router = useRouter()

	//methods
	onMounted(() => {
		aboutMenu.value = [
			{key: 'OverviewView', label:'Overview', link: '/about/overview'},
			{key:'UpdatesView', label: 'Updates', icon: null, link: '/about/updates'},
			{key:'TutorialsView', label:'Tutorials', icon:'<i class="fa-solid fa-arrow-up-right-from-square"></i>', link: 'https://now.nsf.gov/ncses?id=emp_taxonomy_topic&topic_id=be4983151bfbe210080a64a8624bcbc0&&in_context=true'},
			{key:'ContactView', label:'Contact Us', link: '/about/contact'}] 
	})

	function dropdownSelected(pathValue) {
		closeMenu()
		if(pathValue.startsWith('https')) {
			window.open(pathValue, '_blank')
		} else {
			router.push({ path: pathValue })
		}
	}	

	function closeMenu() {
		if(childRefMenu.value.classList.contains('active')) {
			const main = document.getElementsByTagName('main');
			main[0].style.setProperty('display','block')
			childRefMenu.value.classList.toggle('active');
		}
		document.removeEventListener('click', headerMenuEventListener); 
	}

	function toggleMenu () {
		childRefMenu.value.classList.toggle('active');
		if(childRefMenu.value.classList.contains('active')) {
			document.addEventListener('click', headerMenuEventListener);
/* 			if(window.innerWidth < 769) {
				//hide main content to remove vertical scrolling when menu expanded
				childRefMenuToggle.value.style.setProperty('display','none')
			} */
			childRefMenu.value.children[0].focus()			
		} else {
			//childRefMenuToggle.value.style.setProperty('display','block')
			document.removeEventListener('click', headerMenuEventListener);
		}
	}

	function headerMenuEventListener(e) {
		if (!(childRefMenu.value.contains(e.target) ||
			childRefMenuToggle.value.contains(e.target))){
			toggleMenu();
		}		
	}	
	
</script>

<template>
	<header>
		<GovHeader />
		<div class="app-header">
			<div class="header-container">
				<div class="logo-container">
					<div class="logo-wrapper">
						<a href="https://www.nsf.gov" target="_blank">
							<img alt="NSF logo" class="logo" src="@/assets/images/nsf-logo-2020.png" width="66" height="66" />
						</a>
						<div class="logo-divider" />
						<a href="https://ncses.nsf.gov/" target="_blank" style="padding-left:.375rem;">
							<img alt="NCSES logo" class="logo minor" src="@/assets/images/NCSES_Primary_Logo_RGB_Full_Color.png" height="40" />
						</a>
						<h1 class="title">
						NCSES INDICATORS EXPLORER
						</h1>
					</div>
										
				</div>
			</div>
		  	<nav  id="menu" ref="childRefMenu">
				<RouterLink to="/" @click="closeMenu" >				
					<div class="menu-item">
						<div class="menu-link">Home
							<div class="menu-link-underline" />  
						</div>   

					</div>
				</RouterLink>	
				<RouterLink to="/indicatorsexplorer" @click="closeMenu">
					<div class="menu-item">						
						<div class="menu-link">Indicators Explorer
							<div class="menu-link-underline" />
						</div>
					</div>
				</RouterLink>
				<RouterLink to="/accessibility" @click="closeMenu">
					<div class="menu-item">			
						<div class="menu-link">Accessibility
							<div class="menu-link-underline" />
						</div>
					</div>    
				</RouterLink>
				<RouterLink to="/downloads" @click="closeMenu">
					<div class="menu-item">
						<div class="menu-link">Downloads
							<div class="menu-link-underline" />
						</div>
					</div>
				</RouterLink>

				<DropDownMenu :title="'About'" :label="'label'" :icon="'icon'" @menuItemSelected="dropdownSelected" :list="aboutMenu" :keyField="'link'" />

			</nav>
			<div id="menu-toggle" ref="childRefMenuToggle" tabindex="0" @click="toggleMenu" @keydown.enter.prevent="toggleMenu">
				<div class="icon">
					<div></div>
					<div></div>
					<div></div>
				</div>
				<div>Menu</div>
			</div>    
		</div>
		<div class="title-wrapper">
			<h1 class="title-mobile">
			NCSES INDICATORS EXPLORER
			</h1>
		</div>  
	</header>
</template>

<style scoped>
header {
	width:100%; /* 90rem; */
	line-height: 1.5;
	border-top-left-radius: 0.75rem;
	border-top-right-radius: 0.75rem;
	border: 1px solid var(--border-color-Divider, #A9B7C7);	
}

.app-header {
	width:100%;
	height: 5rem;
	line-height: 1.5;
	display: flex;
	justify-content:space-between;
	background-color: var(--surface-color-Default, #fff);
	box-shadow: 0px 0.1875rem 0.375rem 0px rgba(0, 0, 0, 0.15);	
	place-items: center;
}
.header-container {
	
	margin-right:1rem;
}
.logo-container {
	display: block;
	height: 100%;
	/*margin: 0 0 0 2rem;*/
	align-items: flex-start;
	height: 100%;
}
.logo-wrapper {
	display: flex;
	margin: 0 0 0 2rem;
	align-items: center;
	height: 100%;
}
.logo {
  display: block;
  margin: 0;
}

.logo-divider {
	background: var(--border-color-Divider); 
	width: 1px; 
	height: 3.75rem; 
	margin: 0 0.6875rem
}

.title, .title-mobile {
	color: var(--text-Link);
	margin: 0 0 0 1rem;
	/* Regular/H6 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */
	display: flex;
	align-items: center;
}
.title-mobile {
	display:none;
}

#menu {
	display: inline-flex;
	justify-content: flex-end;
	align-items: start;
	gap: 1.875rem;	
	margin-right: 1.25rem;
	margin-top: .5rem;
}

#menu a:focus:not(:focus-visible), .menu-item:focus, .menu-item:focus:not(:focus-visible) {
	outline: 0;
}

.menu-link {
	outline: 0;
	color: var(--text-Primary);
	text-align: center;

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */	
}

.menu-link-underline {
	background: var(--border-color-menu-DividerActive, #C8A52D); 
	height: .25rem; 
	width: 100%; 
	margin-top: 0.5rem;
	visibility: hidden;
}

#menu a {
  text-decoration: none;
}

#menu a:focus {
	outline-color:var(--text-Link, #064291);
	outline-offset: 1rem;;
	outline-width: 1.5px;
}

#menu a:focus:not(:focus-visible) {
	outline: 0;
}

#menu a:hover .menu-link, #menu a:focus .menu-link{
	color: var(--text-Link, #064291);
}

#menu a.router-link-active .menu-link{
	color: var(--text-Link, #064291);
}

#menu a.router-link-active .menu-link-underline, .menu-link-underline.active {
  display: block;
  visibility:visible;
}

/* #menu .menu-link:focus {
	outline:auto;
	outline-color:var(--text-Link, #064291);
	outline-offset: 1rem;;
	outline-width: 1.5px;
 } */

#menu-toggle {
	display: none;
	cursor: pointer;
    margin-right: 1rem;
	padding: .75rem;
	color: var(--text-Link, #064291);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	text-wrap: nowrap;	
}



/* 1023px - iPad */
@media (max-width: 63.9375rem) {	
	body {
		background: var(--surface-color-Default);
	}

	.logo {
		height: 3rem;
		width: auto;
	}
	.logo.minor {
		height: 1.85rem;
	}
	.title {
		color: var(--text-link, #064291);
		margin-left: 1rem;
		/* Regular/H6 */
		font-family: var(--font-family-Title, Roboto);
		font-size: var(--font-size-H6);
		font-style: normal;
		font-weight: 400;
		line-height: var(--font-line-height-H6, 1.75rem); /* 140% */
		display: flex;
		align-items: center;
	}	

	#menu{
		display: none;
		flex-direction: column;
		background: var(--surface-color-Default, #FFF);
		position: absolute;
		padding: 0; 
		margin: 0;
	    width: 23.4375rem;
		top: 6.625rem; /* 106px; account for header */
		right: 0;
		align-items: start;
        justify-content: flex-start;
		z-index: 999;
		gap: 0;
		border: 1px solid var(--border-color-input-Border);

	}

	#menu.active {
		display: flex;
	}

	#menu-toggle {
		display: flex;
		flex-direction: row;		
	}

	#menu-toggle .icon{
		display: flex;
		flex-direction: column;
		cursor: pointer;	
		margin-right: .5rem;
	}

	#menu-toggle .icon div {
		width: 1.5625rem;
		height: 3px;
		background: var(--text-Link);
		margin: 2px 0;
	}	
	
	#menu a {
		width: 100%;
	}

	#menu a.router-link-active .menu-link-underline, .menu-link-underline.active {
		display: none;
	}	

	#menu a.router-link-active .menu-item {
		border-bottom: var(--border-color-menu-DividerActive, #C8A52D) solid .25rem;
	}

	#menu a.router-link-active .menu-link {
		color: var(--text-Link, #064291);
	}

	#menu a:focus {
		outline: none;
		background-color: var(--input-background-Hover, #FAFAFA);	
	}

	.menu-item {
		padding: var(--spacing-xl);
		border-bottom: 1px solid var(--border-color-input-Border);
		width: 100%;
		height:77px;
	}

/* 	.menu-item:last-child {
		border-bottom: 2px solid var(--border-color-input-Border);
	}

	.menu-item.active:last-child {
		border-bottom: var(--border-color-menu-DividerActive, #C8A52D) solid .25rem;
	} */	

	.menu-item:hover  {
		background-color: var(--input-background-Hover, #FAFAFA);	
	}

	.menu-item.about-menu:focus {
		background-color: var(--input-background-Hover, #FAFAFA);	
	}

	.menu-link {
		color: var(--text-Primary, #2C2C2C);
		text-align: left;
		font-family: var(--font-family-Title, Roboto);
		font-size: var(--font-size-H4, 1rem);
		font-style: normal;
		font-weight: 500;
		line-height: var(--font-line-height-H4, 1.5rem); /* 150% */	
		height: var(--font-line-height-H4, 1.5rem); /* 150% */		
	}
}


/* 499px - Mobile phone */
@media (max-width: 31.1875rem) {
	.container {
		border-radius: 0;
		padding: 1rem;
	}
	.app-header {
		min-height: 2rem;
		height: 50%;

	}
	.logo-divider {
		height: 2.375rem;
		margin: 0 0.375rem;
	}
	.logo-container {
		/*height: 60%;*/
	}
	.logo-wrapper {
		margin: 0 0 0 1rem;
		height: 4rem;
	}

	.title-wrapper {
		display:block;
		width: 100%;
		text-align: center;
		background-color: var(--surface-color-Default, #fff);
	}
	.title {
		display: none;
	}

	.title-mobile {
		display:flex;
		width: 100%;
		margin-left: 0;
        justify-content: center;
	}

	#menu {
		top: 8.5rem;
		left: 0;
		width: 100%;
		height: 100%;
	}	

	#menu-toggle {
		margin-right: .25rem;
		padding-right: .25rem;
	}

	.logo-container {
		margin-left: .5rem
	}
}
</style>
